import { Box, useTheme } from "@mui/material";
import { tokens } from "../../../theme";
import ProductOverview from "./Views/ProductOverview";
import VirtualProductOverview from "./Views/VirtualProductOverview";

import TabView3 from "../../../components/theme/TabView3/TabView3";
import { relationProductConfig } from "./relationProductConfig";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTopbar } from "../../../contexts/TopbarProvider";
import UnmatchedProducts from "./Views/UnmatchedProductOverview";
import Batches from "./Views/Batches";
import Lots from "./Views/Lots";
import { useGetProductTotalsQuery } from "../../../newapi/warehouse/productSlice";
import Carriers from "./Views/Carriers";
import { useGetSettingsForRelationQuery } from "../../../newapi/global/generalApiSlice";
import CountingStrategies from "../../warehouse/stock/countingstrategies/views/All";

const Products = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, ready,i18n } = useTranslation();
    const { showExtraComponent, clearExtraComponent,showExtraTitle,clearExtraTitle } = useTopbar();
    
    const { data : productTotals, isLoading: totalIsLoading } = useGetProductTotalsQuery("safetystock");

    const { data: relationSettings } = useGetSettingsForRelationQuery();
    const showCountingStrategies = relationSettings?.find(setting => setting.key === "relation_show_countingstrategies")?.value === "true" ?? false;

    const [config, setConfig] = useState(relationProductConfig(productTotals, showCountingStrategies));

    useEffect(() => {
        if (productTotals && !totalIsLoading) {
            setConfig(relationProductConfig(productTotals, showCountingStrategies));
        }
    }, [productTotals, totalIsLoading, showCountingStrategies]);

    useEffect(() => {
        showExtraTitle(t("products"))

        return () => {
            clearExtraTitle();
        };
    }, [showExtraTitle,clearExtraTitle,t,i18n.language])

    return (
        <Box sx={{background:"", width:1,paddingTop:9}}>
            <TabView3
            tabConfig={config}
                sx={{
                    background:"green",
                    minHeight:"calc(100% - 190px)",
                    background: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                    position:"relative",
                    zIndex:2,
                    
                    display:"flex",
                    flexDirection:"column",

                    "&:before" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        left:0,
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        // transition:"250ms"
                    },

                    "&:after" : {
                        content: "''",
                        display:"block",
                        width:"32px",
                        height:"32px",
                        position:"absolute",
                        top:0,
                        zIndex:1,
                        backgroundColor: `${theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0]}`,
                        top:"40px",
                        right:0,
                        height:"48px",
                        width:"24px",
                        borderTopLeftRadius:"24px",
                        boxShadow: `0 -24px 0 0 ${colors.bg["tertiary"]}`,
                        transform:"scaleX(-1)",
                        // transition:"250ms"
                    },

                    "@media screen and (max-width: 47.9375em)" : {
                        "&:after, &:before" : {
                            top:"-0px"
                        }
                    }
                }}>
                    <>
                        <ProductOverview config={config.productOverview}/>
                        <VirtualProductOverview config={config.virtualProductOverview} />
                        <UnmatchedProducts config={config.unmatchedProducts}/>
                        <Batches config={config.batches}/>
                        <Lots config={config.lots}/>
                        <Carriers config={config.carriers}/>
                        {showCountingStrategies && <CountingStrategies config={config.countingStrategies}/>}
                    </>
                </TabView3>

            

        </Box>
    );
};

export default Products;